var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD33BC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADD7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1072,39 C1063.16342,39 1056,46.1634194 1056,55 C1056,63.8365806 1063.16342,71 1072,71 C1080.83658,71 1088,63.8365806 1088,55 C1088,46.1634194 1080.83658,39 1072,39 Z M1072,42.0967742 C1079.1311,42.0967742 1084.90323,47.8678065 1084.90323,55 C1084.90323,62.1310968 1079.13219,67.9032258 1072,67.9032258 C1064.8689,67.9032258 1059.09677,62.1321935 1059.09677,55 C1059.09677,47.8689032 1064.86781,42.0967742 1072,42.0967742 Z M1081.04542,50.5010968 L1079.59148,49.0354194 C1079.29039,48.731871 1078.80019,48.729871 1078.49665,49.0310323 L1069.37716,58.0772258 L1065.51961,54.1883871 C1065.21852,53.8848387 1064.72832,53.8828387 1064.42477,54.1839355 L1062.95903,55.637871 C1062.65548,55.9389677 1062.65348,56.4291613 1062.95465,56.7327742 L1068.81148,62.6370323 C1069.11258,62.9405806 1069.60277,62.9425806 1069.90632,62.6414194 L1081.0411,51.596 C1081.34458,51.2948387 1081.34652,50.8046452 1081.04542,50.5010968 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-31.2%",
    y: "-25.0%",
    width: "162.5%",
    height: "162.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 0.317647059   0 0 0 0 0.721568627  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-1",
    transform: "translate(-1170.000000, -580.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Precios",
    transform: "translate(120.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(0.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c5bc3a631d0c9c7960aa4cf50070993d.svg";
export { ForwardRef as ReactComponent };